<template>
  <div class="refinement search">
    <div class="refinement-header">
      <div class="title">
        <i class="material-symbols-outlined fill" aria-hidden="true" data-icon="search"></i>
      </div>
      <div class="search-form">
        <input
          v-model="searchStore.keywords"
          type="text"
          class="search-input"
          placeholder="Search"
          aria-label="Search"
          @keyup.enter="keywordUpdate"
        />
        <button
          v-if="hasKeywordTag && keywordsMatchTag"
          type="submit"
          class="search-input"
          aria-label="Search"
          @click.prevent="clearKeywordTag"
        >
          <i class="material-symbols-outlined" aria-hidden="true" data-icon="close"></i>
        </button>
        <button
          v-else
          type="submit"
          class="search-input"
          aria-label="Search"
          @click.prevent="keywordUpdate"
        >
          <i class="material-symbols-outlined" aria-hidden="true" data-icon="search"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSearchStore } from '@/stores/search'
import { computed } from 'vue'

/** DATA **/
const searchStore = useSearchStore()

/** EMITS **/
const emit = defineEmits(['keyword-update', 'keyword-clear'])

/** COMPUTED **/
const hasKeywordTag = computed(
  () => searchStore.hasAny && searchStore.tags.some((tag) => tag.id === 'keywords'),
)

const keywordsMatchTag = computed(() =>
  searchStore.tags.some((tag) => tag.id === 'keywords' && tag.tagLabel === searchStore.keywords),
)

/** METHODS **/
function keywordUpdate() {
  // if empty input don't submit
  if (searchStore.keywords === '') {
    return
  }

  // keywords already updated via v-model, but need to swhich sword
  searchStore.setSortSelected('relevance')

  // emit to re-fetch
  emit('keyword-update', searchStore.keywordsTagItem)
}

function clearKeywordTag() {
  const keywordsTag = searchStore.keywordsTagItem
  keywordsTag.state = false

  searchStore.clearKeywords()

  // emit to re-fetch
  emit('keyword-clear', keywordsTag)
}
</script>
